export const wasLoggoutByRefreshToken = () => {
    return localStorage.getItem('logoutByRefreshToken') === 'true';
  }
  
  export const setLoggoutByRefreshToken = () => {
    localStorage.setItem('logoutByRefreshToken', 'true');
  }
  
  export const removeLoggoutByRefreshToken = () => {
    localStorage.removeItem('logoutByRefreshToken');
  }